import { useMutation, useQueryClient } from 'react-query';
import { message } from 'antd';
import {
  createAnnotation,
  updateAnnotation,
  deleteComment,
  deleteAnnotation,
  saveComment,
} from '@api/annotations';
import { formatNewAnnotation, formatAnnotationComment, formatUpdateAnnotation } from './utils';

// NOTE: message component inside onSuccess breaks react query updates

export function useSaveAnnotation() {
  const queryClient = useQueryClient();

  const mutation = useMutation(
    (payload) => {
      const data = formatNewAnnotation(payload);
      return createAnnotation(data);
    },
    {
      onSuccess: () => {
        queryClient.invalidateQueries('annotations');
      },
      onError: () => {
        message.error('There was an error adding annotation. Please try again later.');
      },
    },
  );

  return mutation;
}

export function useSaveAnnotationComment() {
  const queryClient = useQueryClient();

  const mutation = useMutation(
    (payload) => {
      const data = formatAnnotationComment(payload);
      return saveComment(data);
    },
    {
      onSuccess: () => {
        queryClient.invalidateQueries('annotations');
      },
      onError: () => {
        message.error('There was an error adding comment. Please try again later.');
      },
    },
  );

  return mutation;
}

export const useUpdateAnnotation = () => {
  const queryClient = useQueryClient();

  const mutation = useMutation(
    (payload) => {
      const data = formatUpdateAnnotation(payload);
      return updateAnnotation(data);
    },
    {
      onSuccess: () => {
        queryClient.invalidateQueries('annotations');
      },
      onError: () => {
        message.error('There was an error updating annotation. Please try again later.');
      },
    },
  );

  return mutation;
};

export const useDeleteAnnotation = () => {
  const queryClient = useQueryClient();

  const mutation = useMutation(
    (annotationId) => {
      return deleteAnnotation(annotationId);
    },
    {
      onSuccess: () => {
        queryClient.invalidateQueries('annotations');
      },
      onError: () => {
        message.error('There was an error deleting annotation. Please try again later.');
      },
    },
  );

  return mutation;
};

export const useDeleteAnnotationComment = () => {
  const queryClient = useQueryClient();

  const mutation = useMutation(
    ({ annotationId, commentId }) => {
      return deleteComment(annotationId, commentId);
    },
    {
      onSuccess: () => {
        queryClient.invalidateQueries('annotations');
      },
      onError: () => {
        message.error('There was an error deleting comment. Please try again later.');
      },
    },
  );

  return mutation;
};
